import { useMutation, useQuery } from '@tanstack/react-query';
import { ExpenseApi } from 'api/expense-management/expenses/api';
import { GENERAL_API_STALE } from 'config/query-config';
export const useGetExpenseById = (expenseId, queryOptions)=>{
    return useQuery([
        'expense',
        String(expenseId)
    ], ()=>ExpenseApi.getExpenseById(expenseId), {
        staleTime: 0,
        cacheTime: 0,
        ...queryOptions !== null && queryOptions !== void 0 ? queryOptions : {}
    });
};
export const useCreateExpense = ()=>{
    return useMutation({
        mutationFn: (expense)=>ExpenseApi.createExpense(expense)
    });
};
export const useUpdateExpense = ()=>{
    return useMutation({
        mutationFn: (expense)=>expense.expenseId ? ExpenseApi.updateExpense(expense.expenseId, expense) : Promise.reject(new Error('Expense ID is required'))
    });
};
export const useDeleteExpense = ()=>{
    return useMutation({
        mutationFn: (expenseId)=>ExpenseApi.deleteExpense(expenseId)
    });
};
export const useExtractExpenseDetails = ()=>{
    return useMutation({
        mutationFn: (expenseDocuments)=>ExpenseApi.extractExpenseDetails(expenseDocuments)
    });
};
export const useUpdateUserStatusForExpense = ()=>{
    return useMutation({
        mutationFn: ({ expenseId, entityToApprovalMappingId, entityToApprovalMapping })=>ExpenseApi.updateUserStatusForExpense(expenseId, entityToApprovalMappingId, entityToApprovalMapping)
    });
};
/**
 * This method is used to override the expense status for a given approval workflow level.
 * @description Override expense status
 */ export const useOverrideExpenseStatus = ()=>{
    return useMutation({
        mutationFn: ({ expenseId, approvalWorkflowLevelId, entityToApprovalMapping })=>ExpenseApi.overrideExpenseStatus(expenseId, approvalWorkflowLevelId, entityToApprovalMapping)
    });
};
/**
 * This method is used to perform approvals only when there's no approver attached to an expense.
 * That means there's no approval workflow levels attached to the expense & no entityToApprovalMapping is attached to the expense.
 * @description Force approval on an expense
 */ export const useForceApprovalOnExpense = ()=>{
    return useMutation({
        mutationFn: ({ expenseId, entityToApprovalMapping })=>ExpenseApi.forceApprovalOnExpense(expenseId, entityToApprovalMapping)
    });
};
export const useGetExpenseAuditLogs = (expenseId)=>{
    return useQuery({
        queryKey: [
            'expense',
            expenseId,
            'audit-logs'
        ],
        queryFn: ()=>expenseId ? ExpenseApi.getExpenseAuditLogs(expenseId) : undefined,
        enabled: !!expenseId,
        cacheTime: 0
    });
};
export const EXPENSE_ACCESS_KEY = 'expense-access';
export const useExpenseAccessFlagsOrder = ()=>{
    return useQuery([
        EXPENSE_ACCESS_KEY,
        'expense-access-flags-order'
    ], ()=>ExpenseApi.getExpenseAccessFlagsOrder(), {
        staleTime: GENERAL_API_STALE
    });
};
export const useGetExpenseAccess = (projectId, userId, queryOptions)=>{
    return useQuery([
        EXPENSE_ACCESS_KEY,
        String(projectId),
        String(userId)
    ], ()=>ExpenseApi.getExpenseAccess(projectId, userId), {
        staleTime: GENERAL_API_STALE,
        ...queryOptions
    });
};
export const useGetAccessibleExpenseProjects = ()=>{
    return useQuery({
        queryKey: [
            EXPENSE_ACCESS_KEY,
            'project-access'
        ],
        queryFn: ()=>ExpenseApi.getAccessibleProjects('CREATE')
    });
};
export const useGetAccessibleExpenseUsers = (projectId)=>{
    return useQuery({
        queryKey: [
            EXPENSE_ACCESS_KEY,
            'user-access',
            String(projectId)
        ],
        queryFn: ()=>ExpenseApi.getAccessibleUsers('CREATE', projectId)
    });
};
